import { render, staticRenderFns } from "./DashboardFeedbackSearch.vue?vue&type=template&id=59c44919&scoped=true&"
import script from "./DashboardFeedbackSearch.vue?vue&type=script&lang=js&"
export * from "./DashboardFeedbackSearch.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFeedbackSearch.vue?vue&type=style&index=0&id=59c44919&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c44919",
  null
  
)

export default component.exports